import { render, staticRenderFns } from "./ClassroomLocation.vue?vue&type=template&id=33e15df8&scoped=true"
import script from "./ClassroomLocation.vue?vue&type=script&lang=js"
export * from "./ClassroomLocation.vue?vue&type=script&lang=js"
import style0 from "./ClassroomLocation.vue?vue&type=style&index=0&id=33e15df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e15df8",
  null
  
)

export default component.exports